module.exports = __webpack_public_path__ + "img/shipment-disable.d7675dc9.svg";